import AbstractUIScreen, {getScale} from "../screen/AbstractUIScreen";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig from "../../system/SystemConfig";
import IApp from "../../engine/IApp";
import IUIMessages from "../messages/IUIMessages";
import IScreenData from "../screen/IScreenData";
import {BASE_ELEMENT_IDS} from "../BaseDOM";
import SystemPlatform from "../../system/SystemPlatform";

@injectable()
export default class VLT2UIScreen extends AbstractUIScreen {

    private _platform: SystemPlatform;

    containerPaddingLeft: number = 140
    containerPaddingRight: number = 140
    containerPaddingTop: number = 100
    containerPaddingBottom: number = 120
    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.EngineApp) app: IApp,
        @inject(SERVICE_IDENTIFIER.UIMessages) uiMessages: IUIMessages
    ) {
        super(config, app, uiMessages);

        this._platform = config.platform;
    }

    private displaysCount(): number {
        return this._platform.getDisplaysCount();
    }

    private multiDisplays(): boolean {
        return this.displaysCount() > 1;
    }

    private getTop(): number {
        return this.multiDisplays() ? 720 + 200 : 44;
    }

    protected getContainerData(mode: string) {

        let widthOrig = this.multiDisplays() ? 1920 : this.gameset.stageWidth;
        let heightOrig = this.multiDisplays() ? 1080 * 2 : this.gameset.stageHeight;

        let scale = getScale(window.innerWidth, window.innerHeight, widthOrig, heightOrig);

        let widthScaled = widthOrig * scale;
        let heightScaled = heightOrig * scale;
        let top = Math.floor((window.innerHeight - heightScaled) / 2);
        let left = Math.floor((window.innerWidth - widthScaled) / 2);

        top = top < 0 ? 0 : top;
        left = left < 0 ? 0 : left;

        return {
            scale,
            widthOrig,
            heightOrig,
            widthScaled,
            heightScaled,
            top,
            left
        }
    }


    resize(screenData: IScreenData = this.getScreenData()) {
        this.resizeMode();
        this.resizePreloader(screenData);
        this.resizeContainer(screenData);
        this.resizeCanvas(screenData);
        this.resizeControls(screenData);
        this.resizeMessages(screenData);
    }

    resizeMode(data?: IScreenData) {
        let wrapper = $(document.getElementById(BASE_ELEMENT_IDS.WRAPPER));
        wrapper.addClass("mode-landscape");
    }

    resizeContainer(data: IScreenData) {
        $("#" + BASE_ELEMENT_IDS.CONTAINER).css({"top": data.containerTop, "left": data.containerLeft, "width": data.containerWidthScaled, "height": data.containerHeightScaled });
    }

    protected resizeCanvas(data: IScreenData) {
        this.app.onResize(data);

        // change size of wintable wrapper
        let widthOrig = this.gameset.stageWidth;
        let heightOrig = this.gameset.stageHeight;
        let scale = getScale(
            data.containerWidthScaled,
            data.containerHeightScaled,
            widthOrig,
            heightOrig
        );
        let w = widthOrig * scale;
        let h = heightOrig * scale;
        let wintable: HTMLElement = document.querySelector('#'+BASE_ELEMENT_IDS.WINTABLE_WRAPPER + ' canvas')
        wintable.style.width = `${w}px`;
        wintable.style.height = `${h}px`;

        let left = (this.containerPaddingLeft) * data.canvasScale + "px"
        $(`#${BASE_ELEMENT_IDS.GAME_WRAPPER}`).css({top: this.getTop() * data.canvasScale, left: left});
        $(`#${BASE_ELEMENT_IDS.WINTABLE_WRAPPER}`).css({
            top: this.multiDisplays() ? 0 : 44 * data.canvasScale,
            left: this.multiDisplays() ? 0 : left
        });

        $("#" + BASE_ELEMENT_IDS.AJAX_LOADING_CONTAINER).css("transform", "scale(" + data.canvasScale + ")");
    }

    protected resizeControls(data: IScreenData) {

        let left = (this.containerPaddingLeft) * data.canvasScale + "px"
        $(`#${BASE_ELEMENT_IDS.GAME_CONTROLS_WRAPPER}`).css({
            top: this.getTop() * data.canvasScale,
            left: left,
            width: data.canvasWidthOrig,
            height: data.canvasHeightOrig,
            transform: `scale(${data.canvasScale})`
        });

        let widthOrig = this.gameset.stageWidth;
        let heightOrig = this.gameset.stageHeight;
        let scale = getScale(
            data.containerWidthScaled,
            data.containerHeightScaled,
            widthOrig,
            heightOrig
        );
        $(`#${BASE_ELEMENT_IDS.WINTABLE_CONTROLS_WRAPPER}`).css({
            top: this.multiDisplays() ? 0 : 44 * data.canvasScale,
            left: this.multiDisplays() ? 0 : left,
            width: data.canvasWidthOrig,
            height: data.canvasHeightOrig,
            transform: `scale(${scale})`
        });
    }

    protected resizeMessages(data: IScreenData) {

        $(`.mx-messages-container`).css({
            position: "absolute",
            top: (this.getTop() + 720 / 2) * data.canvasScale,
        });

        this.uiMessages.onResize(data);
    }

    protected resizePreloader(data: IScreenData) {
        let loading = $("#" + BASE_ELEMENT_IDS.LOADING)
        loading.width(window.innerWidth);
        loading.height(window.innerHeight);

        if (this.multiDisplays()) {
            loading.css("padding-top", "25vh");
        }

        $("#" + BASE_ELEMENT_IDS.LOADING_CONTAINER).css("transform", "scale(" + data.canvasScale + ")");

    }
}
